import { SUBSCRIBE_EMAIL_CONTAINER } from '../classnames/home';
import EmailSubscriptionHandler from '../shared/email-subscription-handler';

export default class EmailSubscription {
  initialize = () => {
    const container = document.querySelector(`.${SUBSCRIBE_EMAIL_CONTAINER}`);
    const handler = new EmailSubscriptionHandler(container);

    handler.initialize();
  };
}
